// extracted by mini-css-extract-plugin
export var background = "_5g-6";
export var brand = "_5g-4";
export var check = "_5g-a";
export var container = "_5g-0";
export var dropdown = "_5g-5";
export var enter = "_5g-7";
export var exitActive = "_5g-8";
export var label = "_5g-1";
export var line = "_5g-c";
export var option = "_5g-9";
export var reducedPadding = "_5g-3";
export var select = "_5g-2";
export var selectIcon = "_5g-b";